import React, { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";

import DataTable from "../components/DataTable";
import {createCard, fetchCards, removeCard} from "../api/cardapi";
import { useNavigate } from "react-router-dom";
import {createUser, deleteUser} from "../api/userapi";

export default function Cards() {
    const { token } = useAuth();
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate()

    const fetchData = async () => {
        setLoading(true)
        fetchCards().then((r)=>{
            if(r.success)setCards(r.data);
        })
        setLoading(false)
    };

    useEffect(() => {
        fetchData();
    }, [token]);

    const handleAdd = async () => {
        const tempCard = {
            CardID: "temp-" + Date.now(),
            Name: "Creating new user...",

        };


        setCards((prev) => [tempCard, ...prev]);

        setLoading(true);
        try {
            await createCard()
            await fetchData(true); // silent refresh (no flash)
        } catch {
            // if failed, remove the temp one
            setCards((prev) => prev.filter((item) => item.CardID === tempCard.CardID))
        } finally {
            setLoading(false);
        }
    };

    const handleRemove = async(card) => {
        const prev = cards
        setCards(prev.filter((item)=>item.CardID === card.UserID))

        setLoading(true);
        try {
            await removeCard(card.CardID)
            await fetchData(true); // silent refresh
        } catch {
            // rollback if failed
            setCards(prev);
        } finally {
            setLoading(false);
        }
    };

    const handleRowClick = (card) => {
        navigate("/cards/" + card.CardID);
    };

    if (loading) return <p className="m-3">Loading cards...</p>;
    if (error) return <p className="m-3 text-danger">❌ {error}</p>;

    return (
        <div className="container mt-4">
            <DataTable
                title="Cards"
                columns={[
                    { key: "Name", label: "Name", searchable: true },
                    { key: "Description", label: "Description" },
                    { key: "expires_at", label: "Expires" },
                    { key: "isPublic", label: "Public", filterable: true },
                    { key: "isSharable", label: "Sharable", filterable: true },
                ]}
                data={cards.map((c) => ({
                    ...c,
                    isPublic: c.isPublic ? "Yes" : "No",
                    isSharable: c.isSharable ? "Yes" : "No",
                    expires_at: c.expires_at
                        ? new Date(c.expires_at).toLocaleDateString()
                        : "—",
                }))}
                add
                remove
                onAdd={handleAdd}
                onRemove={handleRemove}
                onRowClick={handleRowClick}
            />
        </div>
    );
}
